module.exports = __webpack_public_path__ + "static/media/loginBackground.6798cb25.svg";